export function getQueryString() {
  const querystring = window.location.href.replace('#', '?').split('?')[1];
  const params = new URLSearchParams(`?${querystring}`);
  return params;
}
